module.exports = __webpack_public_path__ + "static/media/login_full_bg3.0fca4f89.jpg";